import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["clock"]

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const now = new Date()
    const hh = String(now.getHours()).padStart(2, "0")
    const mm = String(now.getMinutes()).padStart(2, "0")
    const ss = String(now.getSeconds()).padStart(2, "0")
    this.clockTarget.textContent = `${hh}:${mm}:${ss}`
  }
}
